app.component("patientInsurance", {
	templateUrl: "app/src/js/components/patientHeader/patientInsurance/patientInsurance.html",
	controller: "patientInsuranceController",
	bindings: {
		hide: "&",
		eyeTitle: "@",
		hideSecondaryInsuranceComponent: "&",
	},
});

app.controller("patientInsuranceController", [
	"$scope",
	"PreOp",
	"NHI",
	"CurrentPatient",
	"PatientAPI",
	function ($scope, PreOp, NHI, CurrentPatient, PatientAPI) {
		this.$onInit = function () {
			$scope.preop = PreOp;
			$scope.PA = PatientAPI;
			this.PA = PatientAPI;
			$scope.CP = CurrentPatient;
			$scope.insuranceProviders = ($scope.CP.patient.insuranceProviders || []).slice();
			$scope.otherInsuranceName = $scope.CP.patient.otherInsuranceName || "";
		};

		$scope.saveInsurance = function () {
			const previousProviders = $scope.CP.patient.insuranceProviders;
			const previousOtherName = $scope.CP.patient.otherInsuranceName;
			$scope.CP.patient.insuranceProviders = $scope.insuranceProviders;
			$scope.CP.patient.otherInsuranceName = $scope.otherInsuranceName;
			if (!$scope.CP.patient.id) {
				$scope.$ctrl.hide();
				return;
			}
			$scope.PA.isProcessing = true;
			$scope.PA.update($scope.CP.patient)
				.then(function (resp) {
					$scope.CP.setPatient(resp.data);
				})
				.then(function () {
					$scope.PA.isProcessing = false;
					$scope.$ctrl.hide();
					$scope.$ctrl.hideSecondaryInsuranceComponent();
				})
				.catch(function (err) {
					// Not saved, so the header goes back to showing what is on file.
					$scope.CP.patient.insuranceProviders = previousProviders;
					$scope.CP.patient.otherInsuranceName = previousOtherName;
					$scope.PA.isProcessing = false;
					console.error("Failed to save insurance:", err && err.status);
				});
		};
	},
]);
